<template>
  <div class="slider-container">
    <!-- 左右箭头 -->
    <div v-if="showNavigation" class="navigation-arrow left-arrow" @click="prevSlide" :class="{ disabled: currentIndex === 0 }">
      <slot name="left-arrow">
        <el-icon><ArrowLeft /></el-icon>
      </slot>
    </div>
    <div v-if="showNavigation" class="navigation-arrow right-arrow" @click="nextSlide" :class="{ disabled: currentIndex >= maxIndex }">
      <slot name="right-arrow">
        <el-icon><ArrowRight /></el-icon>
      </slot>
    </div>

    <!-- 滑动内容区域 -->
    <div class="slider-wrapper">
      <div class="slider-content" ref="sliderRef" :style="{ transform: `translateX(-${currentIndex * (100 / itemsPerScreen)}%)` }">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="slider-item"
          :style="{ width: `${100 / itemsPerScreen}%` }"
        >
          <slot name="item" :item="item" :index="index">
            <div class="default-item">{{ item }}</div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { ArrowLeft, ArrowRight } from '@element-plus/icons-vue';

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  itemsPerScreen: {
    type: Number,
    default: 2,
    validator: (value) => value > 0,
  },
  showNavigation: {
    type: Boolean,
    default: true,
  },
  scrollStep: {
    type: Number,
    default: 1, // 默认每次滑动一个元素，可自定义为 itemsPerScreen
  },
});

const currentIndex = ref(0);
const sliderRef = ref(null);

// 计算最大索引值
const maxIndex = computed(() => {
  return Math.max(props.items.length - props.itemsPerScreen, 0);
});

// 滑动到指定索引
const slideTo = (index) => {
  if (index < 0 || index > maxIndex.value) return;
  currentIndex.value = index;
};

// 上一页
const prevSlide = () => {
  slideTo(currentIndex.value - props.scrollStep);
};

// 下一页
const nextSlide = () => {
  slideTo(currentIndex.value + props.scrollStep);
};

// 键盘左右箭头切换
const handleKeyDown = (e) => {
  if (e.key === 'ArrowRight') {
    nextSlide();
  } else if (e.key === 'ArrowLeft') {
    prevSlide();
  }
};

onMounted(() => {
  window.addEventListener('keydown', handleKeyDown);
});

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeyDown);
});
</script>


<style scoped>
.slider-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  top: -10px;
}

.slider-wrapper {
  width: 100%;
  overflow: hidden;
}

.slider-content {
  display: flex;
  transition: transform 0.3s ease;
  width: 100%;
}

.slider-item {
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.default-item {
  padding: 20px;
  background: #f5f5f5;
  border-radius: 8px;
  text-align: center;
  width: 100%;
}

.navigation-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: background 0.3s ease;
}

.navigation-arrow.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.left-arrow {
  left: 10px;
}

.right-arrow {
  right: 10px;
}
</style>

